<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>设备开关</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>设备开关列表</span>
        </div>
        <div style="display: flex">
          <el-button @click="dialogFormSwitch = true" icon="el-icon-plus" type="primary">添加设备开关</el-button>
          <el-button @click="add_model()" icon="el-icon-plus" type="info">添加开关模型</el-button>
          <el-button @click="dialogFormVisible = true" icon="el-icon-bottom" type="warning">批量导入</el-button>
        </div>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <!-- <el-table-column prop="id" label="ID" width="50"></el-table-column> -->
          <el-table-column prop="number" label="开关模型" width="100"></el-table-column>
          <el-table-column prop="title" label="厂家名称"></el-table-column>
          <el-table-column prop="aside1" label="第1路" width="100"></el-table-column>
          <el-table-column prop="aside2" label="第2路" width="100"></el-table-column>
          <el-table-column prop="aside3" label="第3路" width="100"></el-table-column>
          <el-table-column prop="aside4" label="第4路" width="100"></el-table-column>
          <el-table-column prop="aside5" label="第5路" width="100"></el-table-column>
          <el-table-column prop="aside6" label="第6路" width="100"></el-table-column>
          <el-table-column prop="aside7" label="第7路" width="100"></el-table-column>
          <el-table-column prop="aside8" label="第8路" width="100"></el-table-column>
          <el-table-column prop="aside9" label="第9路" width="100"></el-table-column>
          <el-table-column prop="aside10" label="第10路" width="100"></el-table-column>
          <el-table-column prop="aside11" label="第11路" width="100"></el-table-column>
          <el-table-column prop="aside12" label="第12路" width="100"></el-table-column>
          <el-table-column prop="aside13" label="第13路" width="100"></el-table-column>
          <el-table-column prop="aside14" label="第14路" width="100"></el-table-column>
          <el-table-column prop="aside15" label="第15路" width="100"></el-table-column>
          <el-table-column prop="aside16" label="第16路" width="100"></el-table-column>
          <el-table-column prop="aside17" label="第17路" width="100"></el-table-column>
          <el-table-column prop="aside18" label="第18路" width="100"></el-table-column>
          <el-table-column prop="aside19" label="第19路" width="100"></el-table-column>
          <el-table-column prop="aside20" label="第20路" width="100"></el-table-column>
          <el-table-column prop="aside21" label="第21路" width="100"></el-table-column>
          <el-table-column prop="aside22" label="第22路" width="100"></el-table-column>
          <el-table-column prop="aside23" label="第23路" width="100"></el-table-column>
          <el-table-column prop="aside24" label="第24路" width="100"></el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-dropdown @command="handleCommand" trigger="click">
                <span class="el-dropdown-link">
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'edit')">编辑</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(scope.row.id, 'del')">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination
            class="left"
            @current-change="handleCurrentChange"
            :current-page="page"
            background
            layout="total,prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 导入开关 -->
    <el-dialog title="批量导入开关" width="33%" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="上传文件：" :label-width="formLabelWidth" prop="filesUrl">
          <el-upload
            class="upload-demo"
            name="image"
            action="https://api.iztrv.com/uploadfile"
            :on-success="handleAvatarSuccess"
            :before-remove="beforeRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加开关模板 -->
    <el-dialog title="开关模板" width="30%" :visible.sync="dialogTableVisible">
      <el-form :inline="true" :model="modelForm" :rules="rules_model" ref="modelForm">
        <el-form-item prop="title">
          <el-input placeholder="请输入名称" v-model="modelForm.title"></el-input>
        </el-form-item>
        <el-form-item prop="icon">
          <el-input placeholder="请输入Icon" v-model="modelForm.icon"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="save_model('modelForm')" icon="el-icon-search" type="primary">添加</el-button>
        </el-form-item>
      </el-form>
      <el-table border size="mini" :data="gridData">
        <el-table-column property="title" label="名称" width="*"></el-table-column>
        <el-table-column property="icon" label="Icon" width="200"></el-table-column>
        <el-table-column label="操作" width="160">
          <template #default="scope">
            <el-button size="mini" @click="edit_model(scope.row.id)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del_model_item(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <el-pagination
          class="left"
          @current-change="handleCurrentChangeGrid"
          :current-page="pageGrid"
          background
          layout="prev, pager, next"
          :total="countGrid"
        ></el-pagination>
      </div>
    </el-dialog>

    <!-- 添加开关 -->
    <el-dialog
      title="添加开关"
      :close-on-click-modal="false"
      @close="closeSwitch"
      width="56%"
      :visible.sync="dialogFormSwitch"
    >
      <el-form :inline="true" :model="switchForm" :rules="rules_switch" ref="switchForm">
        <el-col :span="24">
          <el-form-item prop="type" label="开关模型">
            <el-select v-model="switchForm.type" placeholder="请选择">
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="item in devType"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="title" label="名称">
            <el-input placeholder="请输入名称" v-model="switchForm.title"></el-input>
          </el-form-item>
        </el-col>

        <el-form-item :label="'第' + item + '路'" v-for="(item, i) in switchs" :key="i">
          <el-select v-model="switchForm.arys[i]" filterable placeholder="请选择">
            <el-option
              v-for="item in switchData"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-checkbox
            class="ml10 pr50"
            :true-label="1"
            :false-label="0"
            v-model="switchForm.check[i]"
          >隐藏</el-checkbox>
        </el-form-item>

        <el-form-item class="right">
          <el-button @click="save_switch('switchForm')" icon="el-icon-thumb" type="primary">确认添加</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogFormSwitch: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      loading: true,
      tableData: [],
      devType: [],
      page: 0,
      pageGrid: 0,
      count: 0,
      countGrid: 0,
      limit: 10,
      switchs: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
      ],
      fileList: [],
      ruleForm: {
        filesUrl: "",
      },
      rules: {
        filesUrl: [
          { required: true, message: "请上传文件", trigger: "change" },
        ],
      },
      modelForm: {
        title: "",
        icon: "",
      },
      rules_model: {
        title: [{ required: true, message: "请添加名称", trigger: "change" }],
        icon: [{ required: true, message: "请添加Icon", trigger: "change" }],
      },
      switchForm: {
        id: 0,
        type: "",
        title: "",
        arys: [],
        check: [],
      },
      rules_switch: {
        type: [{ required: true, message: "请选择", trigger: "change" }],
        title: [{ required: true, message: "请填写名称", trigger: "change" }],
      },
      search: {
        type: "",
        keys: "",
      },
      gridData: [],
      switchData: [],
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
    that.getIcon();
    that.getDevType();
  },
  methods: {
    closeSwitch() {
      this.switchForm.id = 0;
      this.switchForm.type = "";
      this.switchForm.title = "";
      this.switchForm.arys = [];
      this.switchForm.check = [];
    },

    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      console.log(command);
      switch (command.command) {
        case "edit":
          this.dialogFormSwitch = true;
          this.edit(command.row);
          break;
        case "del":
          this.del_item(command.row);
          break;
      }
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.filesUrl = res.msg;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/dev/switch/import";
        that.axios.post(url, formData).then(() => {
          that.$message.success("批量导入成功");
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },

    edit_model(ids) {
      var that = this;
      that.axios.post("/dev/switch/icon_edit", { id: ids }).then((res) => {
        if (res) {
          that.modelForm = res.data;
        }
      });
    },

    edit(ids) {
      var that = this;
      that.axios.post("/dev/switch/edit", { id: ids }).then((res) => {
        if (res) {
          that.switchForm = res.data;
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    handleCurrentChangeGrid(currentPage) {
      var that = this;
      that.pageGrid = currentPage;
      that.getGridData();
    },

    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios
          .post("/dev/switch/destroy", {
            ids: ids,
          })
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.getList();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          });
      });
    },

    del_model_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios
          .post("dev/switch/icon_destroy", {
            ids: ids,
          })
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.getGridData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          });
      });
    },

    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.search.type = "";
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.type = that.search.type;
      that.axios.post("/dev/switch", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },

    add_model() {
      this.getGridData();
      this.dialogTableVisible = true;
    },

    save_model(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.modelForm;
        var url = "/dev/switch/icon_store";
        if (that.modelForm.id) {
          url = "/dev/switch/icon_update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.modelForm.title = "";
          that.modelForm.icon = "";
          that.getGridData();
        });
      });
    },

    save_switch(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.switchForm;
        var url = "/dev/switch/store";
        if (that.switchForm.id) {
          url = "/dev/switch/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.switchForm.id = 0;
          that.switchForm.type = "";
          that.switchForm.title = "";
          that.switchForm.arys = [];
          that.switchForm.check = [];
          that.dialogFormSwitch = false;
          that.getGridData();
        });
      });
    },

    getGridData() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page_grid");
      that.pageGrid = curr_page ? curr_page - 0 : that.pageGrid;
      formData.page = that.pageGrid;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.type = that.search.type;
      that.axios.post("/dev/switch/icon", formData).then((res) => {
        if (res) {
          that.gridData = res.data.data;
          that.countGrid = res.data.total;
          that.pageGrid = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page_grid") : "";
          that.loading = false;
        }
      });
    },

    getIcon() {
      let that = this;
      that.axios.post("/dev/switch/get_icon").then((res) => {
        if (res) {
          that.switchData = res.data;
        }
      });
    },

    getDevType() {
      let that = this;
      that.axios.post("/dev_type/getCate").then((res) => {
        if (res) {
          that.devType = res.data;
        }
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>